import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, api, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic220 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    remunerationPolicyDesign: {
      remunerationPolicies: "",
      remunerationOversight: "",
      independentConsultants: "",
      shareholderVotesOnRemuneration: "",
    },
    remunerationVoteResults: "",
  });

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);

        setFromData({
          remunerationPolicyDesign: {
            remunerationPolicies:
              res.data.data.GeneralDisclosures2021.determineRemuneration
                .remunerationPolicyDesign.remunerationPolicies,
            remunerationOversight:
              res.data.data.GeneralDisclosures2021.determineRemuneration
                .remunerationPolicyDesign.remunerationOversight,
            independentConsultants:
              res.data.data.GeneralDisclosures2021.determineRemuneration
                .remunerationPolicyDesign.independentConsultants,
            shareholderVotesOnRemuneration:
              res.data.data.GeneralDisclosures2021.determineRemuneration
                .remunerationPolicyDesign.shareholderVotesOnRemuneration,
          },
          remunerationVoteResults:
            res.data.data.GeneralDisclosures2021.determineRemuneration
              .remunerationVoteResults,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          determineRemuneration: { ...fromData },
          submitted2_20: true,
        });
        navigate(`/gri/general-disclosure/2-21/${id}`);
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-21/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe the process for designing organization's remuneration policies and for determining remuneration.",
      subfieldName: "remunerationPolicyDesign",
      fieldName: "remunerationPolicies",
      fields: [
        {
          index: "i.",
          subheading:
            "Describe whether an independent committee or specific board members oversee the process for determining remuneration for the highest governance body and senior executives.",
          fieldName: "remunerationOversight",
        },
        {
          index: "ii.",
          subheading:
            "Describe how does the organization seek and take into consideration the views of stakeholders (including shareholders) regarding remuneration policies.",
          fieldName: "shareholderVotesOnRemuneration",
        },
        {
          index: "iii.",
          subheading:
            "Describe whether does the organization utilize independent remuneration consultants to assist in determining compensation. If so, how is their independence from the organization, board, and executives ensured.",
          fieldName: "independentConsultants",
        },
      ],
    },
    {
      index: "b.",
      heading:
        "Describe whether does the organization hold shareholder votes on remuneration policies or proposals. If so, please report the results of the most recent vote.",
      fieldName: "remunerationVoteResults",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-20 Process to determine remuneration"
        {...{
          inputData,
          fromData,
          setFromData,
          disabled: disabled,
          setErrors,
          errors,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic220;
